import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { DataFiles } from './consts';
import { MoveOnMetadata } from './entities';


/** Filter data by _status > 1 (deleted). */
export function filterDataByStatus(row: MoveOnMetadata): boolean {
    return row._status > 1;
}


@Injectable({
    providedIn: 'root'
})
export class JSONDataService {

    /** JSON data folder. */
    readonly jsonDataFolder: string = 'data';

    /** HTTP client DI. */
    readonly httpClient: HttpClient = inject(HttpClient);

    /** Get data collections. */
    getDataCollection<ReturnType extends MoveOnMetadata>(filename: DataFiles): Observable<ReturnType[]> {
        return this.httpClient.get<ReturnType[]>(`${this.jsonDataFolder}/${filename}`).pipe(
            map(data => data.filter(filterDataByStatus))
        );
    }
}
